// src/components/Shared/AvatarViewer.js
import React from 'react';
import { IoPersonOutline } from 'react-icons/io5';

// Brand static assets
import kondifyIcono from '../../assets/Kondify icono.png';
import kondyBlueprint from '../../assets/Kondy Blueprint.png';
import kondyCiberpunk from '../../assets/Kondy Ciberpunk.png';
import kondyComic from '../../assets/Kondy Comic.png';
import kondyKawaii from '../../assets/Kondy Kawaii.png';
import kondyOrigami from '../../assets/Kondy Origami.png';
import kondyPixelArt from '../../assets/Kondy Pixel Art.png';
import kondyPoly3d from '../../assets/Kondy Poly 3d.png';
import kondyWatercolor from '../../assets/Kondy Watercolor.png';
import kondyOficina from '../../assets/Kondy Oficina.png';
import kondyWhiteBg from '../../assets/Kondy white bg.png';

export const BRAND_AVATARS = [
  { id: 'kondify_icono', name: 'Icono Kondify', src: kondifyIcono },
  { id: 'kondy', name: 'Kondy', src: kondyWhiteBg },
  { id: 'kondy_oficina', name: 'Kondy Oficina', src: kondyOficina },
  { id: 'kondy_comic', name: 'Kondy Comic', src: kondyComic },
  { id: 'kondy_kawaii', name: 'Kondy Kawaii', src: kondyKawaii },
  { id: 'kondy_origami', name: 'Kondy Origami', src: kondyOrigami },
  { id: 'kondy_poly3d', name: 'Kondy Poly 3D', src: kondyPoly3d },
  { id: 'kondy_blueprint', name: 'Kondy Blueprint', src: kondyBlueprint },
  { id: 'kondy_ciberpunk', name: 'Kondy Ciberpunk', src: kondyCiberpunk },
  { id: 'kondy_pixelart', name: 'Kondy Pixel Art', src: kondyPixelArt },
  { id: 'kondy_watercolor', name: 'Kondy Acuarela', src: kondyWatercolor }
];

export const EMOJI_AVATARS = [
  { emoji: '🦁', gradient: 'linear-gradient(135deg, #fda085 0%, #f6d365 100%)', label: 'León' },
  { emoji: '🦄', gradient: 'linear-gradient(135deg, #f5576c 0%, #f093fb 100%)', label: 'Unicornio' },
  { emoji: '🚀', gradient: 'linear-gradient(135deg, #7b2cbf 0%, #2e0854 100%)', label: 'Cohete' },
  { emoji: '🦊', gradient: 'linear-gradient(135deg, #ff5500 0%, #ff9900 100%)', label: 'Zorro' },
  { emoji: '🐱', gradient: 'linear-gradient(135deg, #c2e9fb 0%, #a1c4fd 100%)', label: 'Gato' },
  { emoji: '🎮', gradient: 'linear-gradient(135deg, #00f260 0%, #0575e6 100%)', label: 'Gamer' },
  { emoji: '🔥', gradient: 'linear-gradient(135deg, #ff5858 0%, #f857a6 100%)', label: 'Fuego' },
  { emoji: '☕', gradient: 'linear-gradient(135deg, #dfa579 0%, #c79081 100%)', label: 'Café' },
  { emoji: '🏠', gradient: 'linear-gradient(135deg, #38ef7d 0%, #11998e 100%)', label: 'Casa' },
  { emoji: '👑', gradient: 'linear-gradient(135deg, #e67e22 0%, #f1c40f 100%)', label: 'Corona' }
];

export const parseEmojiAvatar = (url) => {
  if (!url || !url.startsWith('emoji:')) return null;
  const parts = url.split(':');
  return {
    emoji: parts[1] || '👤',
    gradient: parts[2] || 'linear-gradient(135deg, #6366f1, #a855f7)'
  };
};

export const AvatarViewer = ({ avatarUrl, className = 'profile-img', size = 40 }) => {
  if (!avatarUrl) {
    return (
      <div className="avatar-placeholder" style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifySpace: 'center', background: 'rgba(255,255,255,0.15)', borderRadius: '50%', color: '#fff' }}>
        <IoPersonOutline size={size} />
      </div>
    );
  }

  if (avatarUrl.startsWith('emoji:')) {
    const parsed = parseEmojiAvatar(avatarUrl);
    return (
      <div className="avatar-emoji-container" style={{ background: parsed.gradient, width: '100%', height: '100%', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <span style={{ fontSize: `${size * 0.9}px`, lineHeight: 1 }}>{parsed.emoji}</span>
      </div>
    );
  }

  if (avatarUrl.startsWith('brand:')) {
    const brandId = avatarUrl.split(':')[1];
    const brandOption = BRAND_AVATARS.find(b => b.id === brandId);
    if (brandOption) {
      return (
        <div className="profile-img-cutout" style={{ width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden' }}>
          <img 
            src={brandOption.src} 
            alt={brandOption.name} 
            className={className} 
            style={{ width: '100%', height: '100%', objectFit: 'cover' }} 
          />
        </div>
      );
    }
  }

  return (
    <div className="profile-img-cutout" style={{ width: '100%', height: '100%', borderRadius: '50%', overflow: 'hidden' }}>
      <img src={avatarUrl} alt="Perfil" className={className} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
    </div>
  );
};

export default AvatarViewer;
